import dayjs from 'dayjs';

const formatter = Intl.NumberFormat('en', { notation: 'compact' });

// converts date from YYYY-MM-DD to local format
export const prettyPrintDate: (date: string) => string = (date: string) => {
  // return new Date(date).toLocaleDateString();
  return dayjs(date).format('MM/DD');
};

export type DataValue = {
  x: string;
  y: number;
};

export const formatToCompactNumber = (total: number): string => formatter.format(total ?? 0);

export const getValue = (value: number | null | undefined): number =>
  typeof value === 'number' ? value : 0;
